<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Resources</div>
        </div>
        <div class="col-md-2 offset-md-2 text-right center">
          <button type="submit" class="btn btn-primary btn-fill" @click="changeResourceOrder">Order Resources</button>
        </div>
        <div class="col-md-2 text-right center">
          <button type="submit" class="btn btn-primary btn-fill" @click="createResource">Add Resource</button>
        </div>
      </div>
<!--      <div class="row align-items-center mb-1">-->
<!--        <div class="col-md-6">-->
<!--          <div class="h2">Resources</div>-->
<!--        </div>-->
<!--        <div class="col-md-3 offset-md-3 text-right center">-->
<!--          <button type="submit" class="btn btn-primary btn-fill" @click="createResource">Create Resource</button>-->
<!--        </div>-->
<!--      </div>-->
      <!--<div class="row align-items-center mb-1">-->
      <!--<div class="col-md-6">-->
      <!--<div class="h2">Greetings Board</div>-->
      <!--</div>-->
      <!--<div class="col-md-2 offset-md-2 text-right center">-->
      <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
      <!--</div>-->
      <!--<div class="col-md-2 offset-md-2 text-right center">-->
      <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
      <!--</div>-->
      <!--</div>-->
      <div class="table-responsive text-center">
        <l-table class="table table-light  table-light table-bordered table-hover"
                 :columns="resources.columns" :data="resources.data">
          <template slot="table-row" v-if="resources.data.length">
            <tr v-for="(item, index) in resources.data" :key="index" :class="{'inactive': item.status === '0'}">
               <td>{{item.newsResourcesId}}</td>
              <td>{{getResourceType(item.resourceType)}}</td>
              <td>{{item.articleHeader}}</td>
              <td ><img v-if="item.imageUrl" class="table-thumbnail" :title="item.imageUrl":src="item.imageUrl" /></td>
              <td>
                <span class="badge badge-success" v-if="item.active"> Active </span>
                <span class="badge badge-danger" v-else> Inactive </span>
              </td>
              <td>
                <div class="btn-group" role="group">
                  <button class="btn btn-secondary btn-sm" @click="viewResource(item)" v-tooltip.top-center="resources.tooltips.view"><i class="fa fa-eye"></i></button>
                  <button class="btn btn-info btn-sm" @click="editResource(item)" v-tooltip.top-center="resources.tooltips.edit"><i class="fa fa-edit"></i></button>
                </div>
              </td>
            </tr>
          </template>
        </l-table>
      </div>
    </div>
  </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const resourcesColumns = ['ResourceId', 'Type','Header', 'Image', 'Status', 'Operations'];
    export default {
        name: 'Resources',
        components: {
            LTable,
        },
        data() {
        return {
              resources: {
                tooltips: {
                    view: 'View Resource',
                    edit: 'Edit Resource',
                    delete: 'Inactivate Resource',
                    activate:'Activate Resource',
                },
                columns: [...resourcesColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
      changeResourceOrder(){
        this.$router.push({ name: 'Resource Ordering'})
      },
          getResourceType (typeId) {
            if (typeId === 1) {
              return "Featured Article"
            } else if (typeId === 2) {
              return "Set the TONE"
            } else {
              return "Advertisement"
            }
          },
        fetchResources () {
            this.$store.dispatch('FETCH_RESOURCES')
                    .then((res) => {
                        this.resources.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewResource(resource){
            this.$router.push({ name: 'ViewResource', params: { id: resource.newsResourcesId}})
        },
        editResource(resource){
            this.$router.push({ name: 'EditResource', params: { id: resource.newsResourcesId}})
        },
        createResource(){
            this.$router.push({ name: 'CreateResource'})
        },
        // deleteTestimonial(testimonial, boolean){
        //     console.log("testimonial : ", testimonial);
        //     this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {resourceId: resource.newsResourcesId})
        //             .then((res) => {
        //                 console.log("DELETE_SELECTED_EXPERT API res : ", res);
        //                 this.fetchTestimonials();
        //             })
        //             .catch(err => {
        //                 console.log("DELETE_SELECTED_EXPERT API error : ", err);
        //             })
        // }
    },
    created() {
        this.fetchResources();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Resources/Resources.vue